define(
    [
        'core/urls',
        'moment',
        'core/browser-storage',
        'components/modal',
        'components/fake-progress',
        'components/dropdown',
        'components/request-time-manager',
        "core/utilities",
        'components/pagination',
        'components/search-field',
        'core/iterate',
        'components/custom-encode-uri',
        'components/metrics',
        "components/selectize",
        
    ],
    function (
        urls, 
        moment, 
        browser_storage, 
        modal, 
        FakeProgress, 
        DD, 
        requestTM,
        utilities,
        initPagination,
        initSearchField,
        iterate,
        customEncodeUri,
        keyMetrics
    ) 
    {
        let nodes = {
            globalMetrics: document.querySelector(".metrics-header-wrap.global"),
            globalMetricsHeader: document.querySelector(".metrics-header-wrap.global header"),
            surveySelectorWrap: document.querySelector(".survey-selector"),
            surveySelector: document.querySelector(".survey-selector select"),
            surveySelectorOptions: document.querySelectorAll(".survey-selector option"),
            settingsToggle: document.querySelector(".settings-toggle-wrap"),
            surveyStatus: document.querySelector(".survey-status"),
            surveyWrapper: document.querySelector(".survey-wrapper"),
            surveySettings: {
                parent: document.querySelector(".survey-settings"),
                nameStaticWrap: document.querySelector(".survey-settings .survey-name-static"),
                nameStaticText: document.querySelector(".survey-settings .survey-name-static .survey-name"),
                nameEdit: document.querySelector(".survey-settings .survey-name-static .edit-icon"),
                nameInputWrap: document.querySelector(".survey-settings .name-input-wrap"),
                nameInput: document.querySelector(".survey-settings .survey-name-input"),
                nameEditCancel: document.querySelector(".survey-settings .name-input-wrap .close-edit"),
                nameError: document.querySelector(".survey-settings .survey-name-wrap .error"),
                saveButton: document.querySelector(".survey-settings .save-changes"),
                lockedControlsWrap: document.querySelector(".survey-settings .locked-survey-controls"),
                previewControls: document.querySelector(".survey-settings .preview-controls"),
                viewEmailButton: document.querySelector(".survey-settings .view-email"),
                viewSurveyButton: document.querySelector(".survey-settings .view-survey"),
                projectStatusWrap: document.querySelector(".survey-settings .project-status-wrapper"),
                projectStatusSelector: document.querySelector(".survey-settings .project-status-wrapper select"),
                projectPhaseWrap: document.querySelector(".survey-settings .project-phase-wrapper"),
                projectPhaseSelector: document.querySelector(".survey-settings .project-phase-wrapper select"),
                phaseStatusWrap: document.querySelector(".survey-settings .phase-status-wrapper"),
                phaseStatusSelector: document.querySelector(".survey-settings .phase-status-wrapper select"),
                phaseStatusToggleWrap: document.querySelector(".survey-settings .phase-and-status-toggle-wrap"),
                phaseStatusDescription: document.querySelector(".survey-settings .phase-and-status-toggle-wrap .description"),
                phaseStatusError: document.querySelector(".survey-settings .phase-and-status-error"),
                phaseAndStatusToggle: document.querySelector("#phase_and_status_toggle"),
                projectStatusToggle: document.querySelector("#project_status_toggle"),
                projectStatusToggleWrap: document.querySelector(".project-status-toggle-wrap"),
                scheduleError: document.querySelector(".survey-settings .schedule-error"),
                triggeredProject: document.querySelector(".survey-settings .triggered-project"),
                triggeredPhases: document.querySelector(".survey-settings .triggered-phases"),
                triggeredPhasesChips: document.querySelector(".survey-settings .triggered-phases .chips"),
                surveyStatusWrap: document.querySelector(".survey-status-toggle-wrap"),
                surveyStatus: document.querySelector(".survey-status-toggle-wrap #survey_status_toggle"),
                surveyStatusLabel: document.querySelector(".survey-status-toggle-wrap .description"),
                scheduleOptionsWrap: document.querySelector(".survey-settings .schedule-options"),
                settingsProjectError: document.querySelector(".survey-settings .settings-project-error"),
                notificationToggle: document.querySelector(".survey-settings #notification_toggle"),
                commentsToggle: document.querySelector(".survey-settings #acceptComments"),
                marketingPermissionsWrap: document.querySelector(".survey-settings .marketing-permissions-wrap"),
                marketingPermissionsToggle: document.querySelector(".survey-settings #marketingPermissions"),
                googleReviewsToggle: document.querySelector(".survey-settings #googleReviews"),
                googleReviewsInput: document.querySelector(".survey-settings .google-url-input"),
                googleURLEditButton: document.querySelector(".survey-settings .google-url-static .edit-icon"),
                googleStaticWrap: document.querySelector(".survey-settings .google-url-static"),
                googleStaticURL: document.querySelector(".survey-settings .google-url-static .google-url"),
                googleUrlWrap: document.querySelector(".survey-settings .google-url-wrap"),
                googleUrlError: document.querySelector(".survey-settings .google-url-wrap .error"),
            },
            deleteButtons: document.querySelectorAll(".delete-survey"),
            projectWrap: document.querySelector(".project-categories-wrap .project-wrap"),
            projectName: document.querySelector(".project-categories-wrap .project"),
            categories: document.querySelector(".project-categories-wrap .categories"),
            contactsSection: document.querySelector(".survey-recipients"),
            deploymentsSection: document.querySelector(".deployments"),
            deploymentsTable: document.querySelector(".deployments table"),
            deploymentsTableBody: document.querySelector(".deployments table tbody"),
            tableControlsTop: document.querySelector(".table-wrap .table-controls-top"),
            noDeployments: document.querySelector(".deployments .no-results"),
            projectSchedule: document.querySelector(".schedule-wrap .project-schedule"),
            phaseSchedule: document.querySelector(".schedule-wrap .phase-schedule"),
            phasesWrap: document.querySelector(".schedule-wrap .phase-schedule .phases"),
            phaseStatus: document.querySelector(".schedule-wrap .phase-schedule .status"),
            phaseStatusCopy: document.querySelector(".schedule-wrap .phase-schedule .status-copy"),
            contacts: {
                editContactsButton: document.querySelector(".edit-contacts"),
                editContactsCancel: document.querySelector(".survey-recipients .controls .cancel"),
                editContactsSave: document.querySelector(".survey-recipients .controls .save"),
                contactsTableBody: document.querySelector(".survey-recipients .contacts-table tbody"),
                contactsTable: document.querySelector(".contacts-table"),
                contactsUndefined: document.querySelector(".table-results-wrap .undefined"),
                checkAllContacts: document.querySelector(".survey-recipients .check-all"),
            },
            manualContacts: {
                manualContactsWrap: document.querySelector(".manual-contacts .contacts-wrap"),
                manualContactRow: document.querySelector(".manual-contacts .contacts-wrap .contact"),
                addContactButton: document.querySelector(".survey-recipients .add-contact"),
                removeContactButton: document.querySelector(".survey-recipients .contact .remove"),
            },
            loaderElement: document.querySelector(".marketing-loader"),
            loaderHint: document.querySelector(".marketing-loader .loader-bar-wrap_hint"),
            activeSurveyWrap: document.querySelector(".active-survey"),
            noSurveysWrap: document.querySelector(".no-surveys"),
            welcomeModal: document.querySelector(".modal-template-welcome"),
            errorModal: document.querySelector(".modal-template-error"),
            previewModal: document.querySelector(".modal-template-preview"),
            deleteModal: document.querySelector(".modal-template-delete"),
            modal: {
                modal: document.querySelector(".modal_js"),
                close: document.querySelector(".modal-close_js"),
                content: document.querySelector(".modal-content_js"),
                title: document.querySelector(".modal-title_js"),
                bg: document.querySelector(".modal-bg_js"),
                blur: [
                    document.querySelector(".sb-page.survey-manager"),
                    document.querySelector(".sidebar-nav"),
                    document.querySelector(".navigation-top")
                ],
            },
            errorElement: document.querySelector(".survey-error"),
            searchField: {
                searchField: document.querySelector(".search-response_js"),
                resetBtn: document.querySelector(".search-response-reset_js"),
                openBtn: document.querySelector(".search-response-open_js"),
                wrap: document.querySelector(".results-search-wrap_js")
            },
            paginationNodes: {
                wrap: document.querySelector(".pagination_js"),
                page: document.querySelector(".pagination_page_js"),
                hole: document.querySelector(".pagination_hole_js")
            },
            metrics: {
                main: document.querySelector(".metrics-header-wrap.global"),
                wrap: document.querySelector(".metrics-wrap"),
                metricsContainer: document.querySelector(".metrics-wrap .metrics"),
                header: document.querySelector(".page-header.metrics"),
            },
        };

        let metrics = keyMetrics.init(nodes.metrics, "survey-results");
        window.addEventListener("resize", metrics.adjustMetricsHeight);

        let currentSurveyID = '';
        let currentSurveyName = '';
        let createdModal = modal.create(nodes.modal, function (el) {});
        let loadingScreen = new FakeProgress(
            document.querySelector(".marketing-loader .loader-bar-wrap-bar")
        );

        let DDSurveySelector;
        let DDProjectStatusSelector;
        let selectizePhase = $("#project_phase")[0].selectize;

        let currentSurveyType;

        let settingsValidationConfigs = [
            {
                input: nodes.surveySettings.nameInput,
                errorNode: nodes.surveySettings.nameError,
                validations: ["alphaNumeric", "hasValue"],
            },
        ];

        let contactValidationConfigs = [];

        let triggerSchedule = {}
        let pagination 
        let searchField;
        let templateQueryParams = {
            q: "",
            limit: 10,
            page: 1,
            sort: {
                field: "date",
                value: null,
                direction: "desc"        
            }
        }
        let handleTableSort;

        let populateProjectAndCategories = (categories, projectName, companyName) => {
            if(currentSurveyType === "global") {
                nodes.projectWrap.classList.add("hide");
            } else {
                nodes.projectWrap.classList.remove("hide");
                nodes.projectName.innerText = `${companyName} - ${projectName}`;
            }

            
            if(categories.length) {
                nodes.categories.innerHTML = '';
                categories.forEach(category => {
                    nodes.categories.innerHTML += `<span class="chip">${category}</span>`
                })
            } else {
                nodes.categories.innerHTML = '<span class="chip alert">No categories - Please complete survey setup</span>';
            }
            
        }

        let deploymentTableEventListeners = () => {
            let showRecipientButtons = document.querySelectorAll(".deployments-table .show-recipients");

            showRecipientButtons.forEach(button => {
                button.addEventListener("click", () => {
                    let parentRow = button.parentElement.parentElement;
                    let parentClass = parentRow.classList.contains("open") ? "open" : "closed";

                    if (parentClass === "open") {
                        parentRow.classList.remove("open");
                        parentRow.classList.add("closed");
                        button.innerHTML = "Show recipients";
                    } else {
                        parentRow.classList.add("open");
                        parentRow.classList.remove("closed");
                        button.innerHTML = "Hide recipients";
                    }
                })
            })

            handleTableSort = (e) => {
                let el = e.target;
                let key = el.getAttribute("data-id");

                if (key && el.classList.contains("sortable")) {
                    let isAsc = el.classList.contains("asc");
                    
                    templateQueryParams.sort.direction = isAsc ? 'desc' : 'asc';

                    templateQueryParams.sort.field = key;
                    templateQueryParams.sort.value = null;

                    getSurvey(currentSurveyID, () => {
                        iterate(nodes.deploymentsTable.querySelectorAll(".sortable"), (node) => {
                            node.classList.remove("asc");
                            node.classList.remove("desc");
                            node.classList.remove("active");
                        });

                        el.classList.add("active");

                        if (isAsc) {
                            el.classList.add("desc");
                        } else {
                            el.classList.add("asc");
                        }
                    });
                }
            }

            nodes.deploymentsTable.querySelector("thead tr").addEventListener("click", handleTableSort);
        }

        populateDeployments = (deployments) => {
            if(!deployments.length) {
                nodes.noDeployments.classList.remove("hide");
                nodes.deploymentsTable.classList.add("hide");

                if(!templateQueryParams.q || templateQueryParams.q === '') {
                    nodes.tableControlsTop.classList.add("hide");
                }
                return;
            }

            // reset table header
            iterate(nodes.deploymentsTable.querySelectorAll(".sortable"), (node) => {
                node.classList.remove("asc");
                node.classList.remove("desc");
                node.classList.remove("active");

                let dataID = node.dataset.id;
                if(dataID === templateQueryParams.sort.field) {
                    node.classList.add("active");
                    node.classList.add(templateQueryParams.sort.direction)
                }
                
            });

            nodes.tableControlsTop.classList.remove("hide");

            if(!searchField){
                searchField = initSearchField(nodes.searchField, function (value) {
                    templateQueryParams["q"] = customEncodeUri(value);
                    templateQueryParams.page = 1;
                    getSurvey(currentSurveyID);
    
                }, {next: templateQueryParams.q});
            }
            
            let limitNode = document.querySelector(".nps-responses-custom-limit_js");
            limitNode.querySelector("select").value = templateQueryParams.limit + "";

            let DDReset = DD(limitNode, (value) => {
                templateQueryParams["limit"] = value;
                templateQueryParams.page = 1;
                getSurvey(currentSurveyID);
            });

            nodes.noDeployments.classList.add("hide");
            nodes.deploymentsTable.classList.remove("hide");

            let output = '';

            deployments.forEach((deployment, i) => {
                let rowClass = i % 2 === 0 ? 'even' : 'odd';

                let recipients = deployment.contacts.map(contact => {
                    return `
                            <div class="recipient">
                                <strong>${contact.full_name}</strong> — ${contact.email}
                            </div>
                        `;
                })

                output += `
                    <tr class="closed ${rowClass}">
                        <td>${moment(deployment.sent_on).format('MMM DD, YYYY')}</td>
                        <td>${deployment.company}</td>
                        <td>${deployment.project}</td>
                        <td>${deployment.trigger_status}</td>
                        <td class="recipients-column">
                            <button class="button-secondary show-recipients">
                                Show Recipients
                            </button>
                        </td>
                    </tr>
                    <tr class="recipients">
                        <td colspan="5">
                            <div class="recipients-wrap">
                                ${recipients.join('')}
                            </div>
                        </td>
                    </tr>
                `
            })

            nodes.deploymentsTableBody.innerHTML = output;

            deploymentTableEventListeners();

        }

        populateContacts = (contacts) => {
            if(!contacts.length) {
                nodes.contacts.editContactsButton.classList.add("hide");
                nodes.contacts.contactsTable.classList.add("hide");
                nodes.contacts.contactsUndefined.classList.remove("hide");
                return;
            }

            toggleContactsEditing(false)

            nodes.contacts.contactsTableBody.innerHTML = '';
            nodes.contacts.editContactsButton.classList.remove("hide");
            nodes.contacts.contactsTable.classList.remove("hide");
            nodes.contacts.contactsUndefined.classList.add("hide");

            let sortedContacts = contacts.sort((a, b) => a.is_unsubscribed - b.is_unsubscribed || b.active - a.active );

            sortedContacts.forEach((contact, i) => {
                let checked = '';
                let hideContact = "hide-contact"
                let unsubscribed = contact.is_unsubscribed;
                let unsubscribedClass = '';

                if(contact.active && !unsubscribed) {
                    checked = "checked";
                    hideContact = ""
                }

                let checkbox = `
                    <label for="form-${i}-active" class="checkbox-wrap">
                        <input 
                            type="checkbox" 
                            name="form-${i}-active" 
                            id="form-${i}-active" 
                            ${checked}>
                        <div class="checkbox-wrap__checker"></div>
                    </label>
                `;

                if(unsubscribed) {
                    checkbox = `
                        <div class="tooltip-wrap">
                            <div class="icon"><img src="/static/icons/info-red.svg" alt=""></div>
                            <div class="sb-tooltip">User has unsubscribed</div>
                        </div>
                    `;
                    unsubscribedClass = 'disabled'
                }

                nodes.contacts.contactsTableBody.innerHTML += `
                        <tr class="${hideContact}" data-contact-id="${contact.id}">
                            <td class="checkbox">
                                ${checkbox}
                            </td>
                            <td class="name ${unsubscribedClass}">
                                ${utilities.sanitizeData(contact.first_name)} ${utilities.sanitizeData(contact.last_name)}
                            </td>
                            <td class=${unsubscribedClass}>
                                ${utilities.sanitizeData(contact.email)}
                            </td>
                        </tr>
                `;
            })            
        }

        let updateSurveyStatus = (data) => {            
            let triggeredSurveys = triggerSchedule.triggeredPhases.length;
            let totalSurveys = triggerSchedule.activePhaseIds.length + triggerSchedule.triggeredPhases.length;

            if(triggerSchedule.project_status && triggerSchedule.project_status.selected) {
                totalSurveys ++;

                if(triggerSchedule.project_status.triggered) {
                    triggeredSurveys ++;
                }
            }

            nodes.surveyStatus.classList.remove('active', 'paused');

            if(currentSurveyType === "global") {
                let surveyState = data.state === "active" ? "active" : "paused";
                nodes.surveyStatus.classList.add(surveyState);
                nodes.surveyStatus.innerHTML = `
                        <div class="status">${surveyState}</div>
                        <span class="type">
                            Template Survey
                        </span>`;

                if (surveyState === "active") {
                    nodes.surveySettings.surveyStatus.checked = true;
                    nodes.surveySettings.surveyStatusLabel.innerText = "Active";
                    nodes.surveySettings.surveyStatusLabel.classList.remove("paused");
                } else {
                    nodes.surveySettings.surveyStatus.checked = false;
                    nodes.surveySettings.surveyStatusLabel.innerText = "Paused";
                    nodes.surveySettings.surveyStatusLabel.classList.add("paused");
                }
            } else {
                if(triggeredSurveys < totalSurveys) {
                    let s = triggeredSurveys === 1 ? '' : 's';
                    nodes.surveyStatus.classList.add("active");
                    nodes.surveyStatus.innerHTML = `
                        <strong>Active</strong>
                        <span class="deployments">
                            <strong>${triggeredSurveys}</strong> of <strong>${totalSurveys}</strong> survey periods complete
                        </span>`
                } else {
                    nodes.surveyStatus.classList.remove("active");
                    nodes.surveyStatus.innerHTML = `
                        <strong>Complete</strong>
                        <span class="deployments">
                            <strong>${totalSurveys}</strong> of <strong>${totalSurveys}</strong> survey periods complete
                        </span>`
                }
            }
        }

        let populateSettings = (data, id) => {
            let surveyDeployed = data.deployed;
            let editSurveyButton = document.querySelector(".settings-panel .edit-survey");

            nodes.surveySettings.notificationToggle.checked = data.send_deployment_notification;
            nodes.surveySettings.marketingPermissionsToggle.checked = data.ask_for_marketing_permissions;
            nodes.surveySettings.googleReviewsToggle.checked = data.is_google_reviews_available;
            nodes.surveySettings.googleStaticURL.innerHTML = utilities.sanitizeData(data.google_reviews_url) || "URL not entered";
            nodes.surveySettings.commentsToggle.checked = data.accept_comments;

            if(data.accept_comments) {
                nodes.surveySettings.marketingPermissionsWrap.classList.remove("disabled");
            } else {
                nodes.surveySettings.marketingPermissionsWrap.classList.add("disabled");
            }

            if(data.google_reviews_url && data.is_google_reviews_available) {
                nodes.surveySettings.googleUrlWrap.classList.remove("disabled");
                nodes.surveySettings.googleReviewsInput.value = data.google_reviews_url;
            } else {
                nodes.surveySettings.googleUrlWrap.classList.add("disabled");
            }

            nodes.surveySettings.nameStaticWrap.setAttribute("data-original-value", utilities.sanitizeData(data.name));
            nodes.surveySettings.googleStaticWrap.setAttribute("data-original-value", data.google_reviews_url);

            nodes.surveySettings.phaseStatusToggleWrap.classList.remove("disabled");
            nodes.surveySettings.phaseStatusError.classList.add("hide");

            nodes.settingsToggle.classList.remove("hide");
            nodes.surveySettings.parent.classList.remove("disabled");

            let triggeredChipsElement = document.querySelector(".phase-and-status-toggle-wrap .triggered-chips");
            if(triggeredChipsElement) triggeredChipsElement.remove();

            // triggerSchedule is used to keep track of data to prevent unnecessary iterations
            triggerSchedule = {
                project_status: null,
                project_phase_status: null,
                project_phases: [],
                project_status_triggered: false,
                triggeredPhases: [],
                activePhaseIds: [],
                allPhasesTriggered: false,
            }

            // populate project status dropdown
            nodes.surveySettings.projectStatusSelector.innerHTML = '';
            data.project_statuses.forEach(projectStatus => {
                let newOption = document.createElement("option");
                newOption.setAttribute("value", projectStatus.id);
                newOption.innerText = projectStatus.name;

                nodes.surveySettings.projectStatusSelector.appendChild(newOption);

                if(projectStatus.selected) triggerSchedule.project_status = projectStatus;
            })

            // show project as triggered (or not) - only for single surveys
            if(triggerSchedule.project_status && triggerSchedule.project_status.triggered && currentSurveyType !== 'global') {
                nodes.surveySettings.projectStatusToggleWrap.classList.add("triggered");
            } else {
                nodes.surveySettings.projectStatusToggleWrap.classList.remove("triggered");
            }

            // initialize drop down for project status
            DDProjectStatusSelector = DD(nodes.surveySettings.projectStatusWrap, (value) => {
                editSaveState();
            });

            // if project status has been saved, select it in the dropdown, and enable the toggle
            if(triggerSchedule.project_status) {
                DDProjectStatusSelector.chooseOption(triggerSchedule.project_status.id);
                if(nodes.surveySettings.projectStatusToggle.checked === false) {
                    nodes.surveySettings.projectStatusToggle.click();
                }
            } else {
                // no project status saved - disable toggle
                if(nodes.surveySettings.projectStatusToggle.checked === true) {
                    nodes.surveySettings.projectStatusToggle.click();
                }
            }

            // populate project phases multiselect
            selectizePhase.clear();
            selectizePhase.clearOptions();

            if(data.project_phases) {
                data.project_phases.forEach(phase => {
                    // maintain a list of all triggered phases
                    triggerSchedule.project_phases.push(phase);
                    if(phase.triggered) {
                        triggerSchedule.triggeredPhases.push(phase)
                    } else {
                        if(phase.selected) {
                            // maintain a list of all selected phases which haven't been triggered
                            triggerSchedule.activePhaseIds.push(phase.id)
                        }
                        // add all non-triggered options to multiselect
                        selectizePhase.addOption({value: phase.id, text: phase.name});
                    }
                })
            }

            if(currentSurveyType === 'global') {
                // display different settings for global surveys
                nodes.surveySettings.phaseStatusToggleWrap.classList.add("hide");
                nodes.surveySettings.surveyStatusWrap.classList.remove("hide");
            } else {
                nodes.surveySettings.surveyStatusWrap.classList.add("hide");
                nodes.surveySettings.phaseStatusToggleWrap.classList.remove("hide");
                // select all saved phases in multiselect, which haven't been triggered yet
                if(triggerSchedule.activePhaseIds.length) selectizePhase.setValue(triggerSchedule.activePhaseIds);

                // add triggered phases manually to multiselect 
                // these will be for display only - not clickable
                if(triggerSchedule.triggeredPhases && triggerSchedule.triggeredPhases.length) {
                    let phaseChips = '';
                    let output = document.createElement('div');
                    output.classList.add("triggered-chips");

                    triggerSchedule.triggeredPhases.forEach(phase => {
                        phaseChips += `<span class="chip">${phase.name}</span>`
                    })

                    output.innerHTML =  `${phaseChips}`;
                    let projectPhaseMultiSelect = document.querySelector(".project-phase-wrapper .selectize-input");
                    projectPhaseMultiSelect.append(output);
                }

                // switch phase toggle on if there are saved, non-triggered phases
                if (triggerSchedule.activePhaseIds.length) {
                    if(!nodes.surveySettings.phaseAndStatusToggle.checked) {
                        nodes.surveySettings.phaseAndStatusToggle.click();
                        nodes.surveySettings.saveButton.classList.add("disabled");
                    }
                } else {
                    // no saved phases - turn toggle off
                    if(nodes.surveySettings.phaseAndStatusToggle.checked) {
                        nodes.surveySettings.phaseAndStatusToggle.click();
                        nodes.surveySettings.saveButton.classList.add("disabled");
                    }
                }

                // if there are zero phases remaining that haven't been triggered,
                // add disabled class to wrapper
                if(data.project_phases.length) {
                    if(triggerSchedule.triggeredPhases.length === data.project_phases.length) {
                        nodes.surveySettings.phaseAndStatusToggle.click();
                        nodes.surveySettings.saveButton.classList.add("disabled");
                        triggerSchedule.allPhasesTriggered = true;
                        nodes.surveySettings.phaseStatusToggleWrap.classList.add("all-triggered");
                    } else {
                        triggerSchedule.allPhasesTriggered = false;
                        nodes.surveySettings.phaseStatusToggleWrap.classList.remove("all-triggered");                
                    }
                } else {
                    nodes.surveySettings.phaseStatusToggleWrap.classList.add("disabled");
                    nodes.surveySettings.phaseStatusError.classList.remove("hide");
                }

                // populate phase status select element
                if(data.project_phase_statuses) {
                    nodes.surveySettings.phaseStatusSelector.innerHTML = '';
                    data.project_phase_statuses.forEach(phaseStatus => {
                        let newOption = document.createElement("option");
                        newOption.setAttribute("value", phaseStatus.id);
                        newOption.innerText = phaseStatus.name;

                        nodes.surveySettings.phaseStatusSelector.appendChild(newOption);

                        if(phaseStatus.selected) triggerSchedule.project_phase_status = phaseStatus;
                    })
                }

                // initialize phase status dropdown
                let DDPhaseStatusSelector = DD(nodes.surveySettings.phaseStatusWrap, (value) => {
                    editSaveState();
                });
                
                // select saved phase status if applicable
                if(triggerSchedule.project_phase_status) {
                    DDPhaseStatusSelector.chooseOption(triggerSchedule.project_phase_status.id)
                }
            }

            // if survey has not been triggered once, show edit survey button
            if(!surveyDeployed) {
                editSurveyButton.setAttribute("href", urls['projects:start_projects_survey'](id))
                editSurveyButton.classList.remove("hide");
                nodes.surveySettings.previewControls.classList.add("hide");
            } else {
                // otherwise hide edit button and show preview buttons
                nodes.surveySettings.previewControls.classList.remove("hide");
                editSurveyButton.classList.add("hide");
            }
            
            // reset survey name to current survey
            nodes.surveySettings.nameStaticText.innerHTML = utilities.sanitizeData(data.name);
            nodes.surveySettings.nameInput.value = data.name;

            // update survey status
            updateSurveyStatus(data);

            setTimeout(() => {
                utilities.setSettingsHeight(nodes.surveySettings, true);
            }, 100);
        }

        let populateSchedule = () => {
            nodes.phaseSchedule.classList.add("hide");
            nodes.projectSchedule.classList.add("hide");

            if(triggerSchedule.project_status) {
                nodes.projectSchedule.querySelector(".chip.status").innerHTML = triggerSchedule.project_status.name;
                nodes.projectSchedule.classList.remove("hide");

                if(triggerSchedule.project_status.triggered && currentSurveyType !== 'global') {
                    nodes.projectSchedule.querySelector(".chip.project").classList.add("triggered");
                } else {
                    nodes.projectSchedule.querySelector(".chip.project").classList.remove("triggered");
                }
            }

            if(triggerSchedule.project_phase_status) {
                let statusCopy = triggerSchedule.project_phases.length > 1 ? "statuses are" : "status is";
                nodes.phaseStatusCopy.innerHTML = statusCopy;

                nodes.phasesWrap.innerHTML = '';
                triggerSchedule.project_phases.forEach(phase => {
                    if(phase.selected) {
                        let triggered = phase.triggered ? 'triggered' : '';
                        nodes.phasesWrap.innerHTML += `<span class="chip ${triggered}">${phase.name}</span>`
                    }
                })

                nodes.phaseStatus.innerHTML = triggerSchedule.project_phase_status.name;
                nodes.phaseSchedule.classList.remove("hide");
            }
        }

        let renderProjectError = (showError, projectName) => {
            let editSurveyButton = document.querySelector(".settings-panel .edit-survey");

            if(showError) {
                let projectNameElement = nodes.errorElement.querySelector(".project-name");
                projectNameElement.innerHTML = projectName;
                nodes.errorElement.classList.remove("hide");
                //hide survey schedule options
                nodes.surveySettings.settingsProjectError.classList.remove("hide");
                nodes.surveySettings.scheduleOptionsWrap.classList.add("hide");
                editSurveyButton.classList.add("disabled");
            } else {
                nodes.errorElement.classList.add("hide");
                //hide survey schedule options
                nodes.surveySettings.settingsProjectError.classList.add("hide");
                nodes.surveySettings.scheduleOptionsWrap.classList.remove("hide");
                editSurveyButton.classList.remove("disabled");
            }
        }

        /* 
            id = survey ID
            callback = callback function
            isNewSurveySelection = BOOL (true is selecting a new survey, false if requesting pagination/sorting/search)
        */
        let getSurvey = async (id, callback, isNewSurveySelection) => {                         
            loadingScreen.reset();
            nodes.loaderElement.classList.remove("disabled");
            loadingScreen.startLoading(15);

            let query = "";
            
            if(isNewSurveySelection) {         
                //reset query params
                templateQueryParams = {
                    q: "",
                    limit: 10,
                    page: 1,
                    sort: {
                        field: "date",
                        value: null,
                        direction: "desc"        
                    }
                }
            } 

            query = `?data=${encodeURIComponent(JSON.stringify(templateQueryParams))}`;

            let url = `${urls['projects:survey_data'](id)}${query}`;

            await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then((response) => {
                if(response.status === 200) {
                    return response.json()
                } else {
                    if(response.status === 403 || response.status === 500) {
                        createdModal.open({
                            class: "error-modal",
                            content: nodes.errorModal.innerHTML,
                            title: "Connection Error"
                        }, function (el) {
                            nodes.modal.bg.addEventListener("click", () => {
                                window.location = urls['ticketsource:connectwise']();
                            })
                        });
                    } else {
                        createdModal.open({
                            class: "error-modal",
                            content: "Something went wrong. Please try again or contact tech support if issue persists",
                            title: ""
                        }, function (el) {
                            nodes.modal.bg.addEventListener("click", () => {
                                window.location = urls['eports:dashboard']();
                            })
                        });
                    }

                    throw new Error(response.status);
                }  
            })
            .then((data) => {
                renderProjectError(data.error === 404 ? true : false, data.project_name);
                currentSurveyType = data.is_global ? "global" : "single";
                nodes.activeSurveyWrap.dataset.type = currentSurveyType;

                populateProjectAndCategories(data.categories, data.project_name, data.company_name);
                populateSettings(data, id);
                populateSchedule();

                if(currentSurveyType === "single") {
                    populateContacts(data.contacts);
                    nodes.contactsSection.classList.remove("hide");
                    nodes.deploymentsSection.classList.add("hide");
                } else {
                    nodes.deploymentsTable.querySelector("thead tr").removeEventListener("click", handleTableSort);
                    populateDeployments(data.deployments);
                    nodes.contactsSection.classList.add("hide");
                    nodes.deploymentsSection.classList.remove("hide");

                    if(!pagination){
                        pagination = initPagination(nodes.paginationNodes, function (value) {
                            templateQueryParams.page = value;
                            getSurvey(currentSurveyID);
                        }, templateQueryParams);
                    }  
                    templateQueryParams.page = data.page_info.current_page;
                    pagination.set(data.page_info);
                }

                nodes.activeSurveyWrap.classList.remove("hide");

                nodes.loaderElement.classList.add("disabled");
                loadingScreen.loadFinish();

                browser_storage.setItem("last-visited-survey", id);

                currentSurveyID = id;
                currentSurveyName = data.name;

                if (callback) callback(data);
            })
            .catch(error => {
                console.log(error)
            });

            
        }

        let toggleContactsEditing = (showControls) => {
            if(showControls) {
                nodes.contactsSection.classList.add("editing");
            } else {
                nodes.contactsSection.classList.remove("editing");
            }
        }

        let showPreview = async (type) => {
            let url = type === "email" ? urls['projects:email_preview'](currentSurveyID) : urls['projects:survey_preview'](currentSurveyID);
            let title = type === "email" ? "Email Preview" : "Survey Preview";
            
            await fetch(url, {
                method: "GET",
            })
            .then(response => response.text())
            .then((text) => {
                let iframe = nodes.previewModal.querySelector('iframe');
                iframe.srcdoc = text;
                createdModal.open({
                    class: `${type}-preview-modal`,
                    content: nodes.previewModal.innerHTML,
                    title,
                }, function (el) {
                    // modal callback
                });
            })
        }

        let validateScheduling = () => {
            let isValid = true;
            let errorElement = document.querySelector(".schedule-error");
            errorElement.classList.add("hide");
    
            // scheduling
            if(nodes.surveySettings.projectStatusToggle.checked === false && nodes.surveySettings.phaseAndStatusToggle.checked === false) {
                nodes.surveySettings.scheduleError.innerText = "Please select at least one scheduling option.";
                nodes.surveySettings.scheduleError.classList.remove("hide");
                isValid = false;
            }
    
            if(nodes.surveySettings.phaseAndStatusToggle.checked === true && currentSurveyType !== "global") {
                let projectPhaseMultiSelect = document.querySelector(".project-phase-wrapper .selectize-input");
                if(!projectPhaseMultiSelect.classList.contains("has-items") && !triggerSchedule.allPhasesTriggered) {
                    nodes.surveySettings.scheduleError.innerText = "Please select at least one project phase, or disable this option.";
                    nodes.surveySettings.scheduleError.classList.remove("hide");
                    isValid = false;
                }
            }
    
            return isValid;
        }

        let updateSurveySettings = () => {      
            let selectedPhases = selectizePhase.getValue();
            let selectedPhaseIntegers = [];

            selectedPhases.forEach(id => {
                selectedPhaseIntegers.push(parseInt(id));
            })

            if(nodes.surveySettings.googleReviewsToggle.checked && nodes.surveySettings.commentsToggle.checked) {
                settingsValidationConfigs.push(
                    {
                        input: nodes.surveySettings.googleReviewsInput,
                        errorNode: nodes.surveySettings.googleUrlError,
                        validations: ["isValidURL", "hasValue"],
                    }
                )
            }

            let formIsValid = utilities.validateForm(settingsValidationConfigs, nodes.surveySettings.parent);
            let schedulingValid = validateScheduling();

            if(!schedulingValid || !formIsValid) {
                utilities.setSettingsHeight(nodes.surveySettings);
                return;
            }

            let singleSurveyPayload = {
                "name": nodes.surveySettings.nameInput.value,
                "project_status_toggle": nodes.surveySettings.projectStatusToggle.checked,
                "project_status": nodes.surveySettings.projectStatusSelector.value * 1,
                "phase_and_status_toggle": nodes.surveySettings.phaseAndStatusToggle.checked,
                "project_phases": selectedPhaseIntegers,
                "phase_status": nodes.surveySettings.phaseStatusSelector.value * 1,
                "send_deployment_notification": nodes.surveySettings.notificationToggle.checked,
            }

            let globalSurveyPayload = {
                "name": nodes.surveySettings.nameInput.value,
                "state": nodes.surveySettings.surveyStatus.checked ? "active" : "paused",
                "project_status": nodes.surveySettings.projectStatusSelector.value * 1,
                "project_status_toggle": true,
                "phase_and_status_toggle": false,
                "send_deployment_notification": nodes.surveySettings.notificationToggle.checked,
            }

            let surveyPayload = currentSurveyType === "global" ? globalSurveyPayload : singleSurveyPayload;

            surveyPayload["accept_comments"] = nodes.surveySettings.commentsToggle.checked;

            if(nodes.surveySettings.commentsToggle.checked) {
                surveyPayload["ask_for_marketing_permissions"] = nodes.surveySettings.marketingPermissionsToggle.checked;
                surveyPayload["is_google_reviews_available"] = nodes.surveySettings.googleReviewsToggle.checked;

                if(nodes.surveySettings.googleReviewsToggle.checked) {
                    surveyPayload["google_reviews_url"] = nodes.surveySettings.googleReviewsInput.value;
                    surveyPayload["google_reviews_url"] = nodes.surveySettings.googleReviewsInput.value;
                }
            }

            loadingScreen.reset();
            nodes.loaderElement.classList.remove("disabled");
            loadingScreen.startLoading(15);

            fetch(urls['projects:survey_manager_update'](currentSurveyID), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(surveyPayload),
            })
            .then(() => {
                let nameInput = document.querySelector(".survey-settings .survey-name-input");

                if(currentSurveyName !== nameInput.value) {
                    DDSurveySelector.removeOption(currentSurveyID, currentSurveyName, false);
                    DDSurveySelector.addOption(currentSurveyID, nameInput.value)
                    currentSurveyName = nameInput.value;
                }
                
                nodes.surveySettings.saveButton.classList.add("disabled");
                nodes.settingsToggle.click();

                getSurvey(currentSurveyID);

                nodes.loaderElement.classList.add("disabled");
                loadingScreen.loadFinish();
            })
        }

        let deleteSurvey = () => {
            createdModal.open({
                class: "delete-modal",
                content: `
                    <p>This action cannot be undone</p>
                    <div class="controls">
                        <button class="button-secondary cancel">Cancel</button>
                        <button class="button-primary confirm-delete">Delete</button>
                    </div>
                `,
                title: `Delete "${currentSurveyName}"?`
            }, function (el) {
                el.querySelector(".cancel").addEventListener("click", createdModal.close);
                el.querySelector(".confirm-delete").addEventListener("click", () => {
                    fetch(urls['projects:survey_delete'](currentSurveyID), {
                        method: 'DELETE',
                    })
                    .then((response) => {
                        createdModal.close();

                        let surveySelectorOptions = document.querySelectorAll(".survey-selector option");

                        if(surveySelectorOptions.length > 1) {
                            DDSurveySelector.removeOption(currentSurveyID, currentSurveyName, true);
                            let nextSurveyId = document.querySelectorAll(".survey-selector option")[0].value;
                            getSurvey(nextSurveyId);
                        } else {
                            nodes.activeSurveyWrap.classList.add("hide");
                            nodes.noSurveysWrap.classList.remove("hide");
                        }
                    })
                });
            });
        }

        let buildValidationConfigs = () => {
            // rebuilds configs each time it is called to capture all manual contact inputs user has generated
            nodes.manualContacts.firstNames = document.querySelectorAll(".manual-contacts input.first-name");
            nodes.manualContacts.firstNameErrors = document.querySelectorAll(".manual-contacts .error-first-name");
            nodes.manualContacts.lastNames = document.querySelectorAll(".manual-contacts input.last-name");
            nodes.manualContacts.lastNameErrors = document.querySelectorAll(".manual-contacts .error-last-name");
            nodes.manualContacts.emails = document.querySelectorAll(".manual-contacts input.email");
            nodes.manualContacts.emailErrors = document.querySelectorAll(".manual-contacts .error-email");
    
            contactValidationConfigs = [];
    
            nodes.manualContacts.firstNames.forEach((node, i) => {
                contactValidationConfigs.push({
                    input: nodes.manualContacts.firstNames[i],
                    errorNode: nodes.manualContacts.firstNameErrors[i],
                    validations: ["alphaNumeric", "hasValue"],
                })
            })
        
            nodes.manualContacts.lastNames.forEach((node, i) => {
                contactValidationConfigs.push({
                    input: nodes.manualContacts.lastNames[i],
                    errorNode: nodes.manualContacts.lastNameErrors[i],
                    validations: ["alphaNumeric", "hasValue"],
                })
            })
        
            nodes.manualContacts.emails.forEach((node, i) => {
                contactValidationConfigs.push({
                    input: nodes.manualContacts.emails[i],
                    errorNode: nodes.manualContacts.emailErrors[i],
                    validations: ["email", "hasValue"],
                })
            })
        }

        let saveContacts = () => {
            loadingScreen.reset();
            nodes.loaderElement.classList.remove("disabled");
            loadingScreen.startLoading(15);

            let updatedContacts = [];
            let createdContacts = [];
            let existingContactSelected = false;

            let existingContacts = document.querySelectorAll(".contacts-table tbody tr");
            let newContacts = document.querySelectorAll(".manual-contacts .contact")

            existingContacts.forEach(contact => {
                let id = contact.dataset.contactId;
                let checkbox = contact.querySelector(".checkbox input");

                if(checkbox) {
                    updatedContacts.push({
                        id,
                        active: checkbox.checked
                    })
    
                    if(checkbox.checked) {
                        existingContactSelected = true;
                    }
                }
            })
            
            newContacts.forEach(contact => {
                let firstName = contact.querySelector("input.first-name").value;
                let lastName = contact.querySelector("input.last-name").value;
                let email = contact.querySelector("input.email").value;

                if(firstName !== '') {
                    createdContacts.push({
                        first_name: firstName,
                        last_name: lastName,
                        email
                    })
                }                
            })

            let payload = {
                updated_contacts: updatedContacts,
            }

            if(createdContacts.length) {
                payload.created_contacts = createdContacts;
            }

            let formIsValid;
            if (
                existingContactSelected &&
                newContacts.length == 1 &&
                newContacts[0].querySelector(".first-name").value === '' &&
                newContacts[0].querySelector(".last-name").value === '' &&
                newContacts[0].querySelector(".email").value === ''
            ) {
                // no validation required if an existing contact is selected and
                // there is only a single empty row of manual contacts
                formIsValid = true;
            } else {
                // manual contacts are partially entered or have multiple rows - we must validate them
                buildValidationConfigs();
                formIsValid = utilities.validateForm(contactValidationConfigs, nodes.manualContacts.manualContactsWrap);
            }

            if(formIsValid) {
                fetch(urls['projects:contacts_update'](currentSurveyID), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                })
                .then(() => {
                    getSurvey(currentSurveyID);
                    toggleContactsEditing(false);

                    if(createdContacts.length) {
                        newContacts.forEach((contact, i) => {
                            if(i > 0) {
                                contact.remove();
                            } else {
                                let firstName = contact.querySelector("input.first-name");
                                let lastName = contact.querySelector("input.last-name");
                                let email = contact.querySelector("input.email");
                                
                                firstName.value = '';
                                lastName.value = '';
                                email.value = '';
                            }    
                        })
                    }

                    nodes.loaderElement.classList.add("disabled");
                    loadingScreen.loadFinish();
                });
            } else {
                nodes.loaderElement.classList.add("disabled");
                loadingScreen.loadFinish();
            }
        }

        let editSaveState = () => {
            nodes.surveySettings.saveButton.classList.remove("disabled");
        }

        let createEventListeners = () => {
            nodes.globalMetricsHeader.addEventListener("click", (event) => {
                if(browser_storage.getItem("survey-global-stats-collapse") === "false") {
                    browser_storage.setItem("survey-global-stats-collapse", "true");
                    nodes.globalMetrics.classList.add("collapse");
                } else {
                    browser_storage.setItem("survey-global-stats-collapse", "false");
                    nodes.globalMetrics.classList.remove("collapse");
                }
            })

            nodes.settingsToggle.addEventListener("click", (event) => {
                event.currentTarget.classList.contains("active") ? event.currentTarget.classList.remove("active") : event.currentTarget.classList.add("active");
                let settings = nodes.surveySettings.parent;
                settings.classList.contains("hide") ? settings.classList.remove("hide") : settings.classList.add("hide");

                if(event.currentTarget.classList.contains("active")) {
                    setTimeout(() => {
                        settings.scrollIntoView({behavior: "smooth", block: "center"})
                    }, 300)
                }

                document.querySelectorAll(".survey-settings .close-edit").forEach(node => {
                    if(!node.parentElement.classList.contains("hide")){
                        node.click();
                    }
                })
            })

            document.querySelectorAll(".survey-settings .edit-icon").forEach(icon => {
                icon.addEventListener("click", () => {
                    let targetName = icon.getAttribute("data-name");
                    document.querySelector(`[data-name="${targetName}"] .static-wrap`).classList.add("hide");
                    document.querySelector(`[data-name="${targetName}"] .input-wrap`).classList.remove("hide");
                    document.querySelector(`[data-property="${targetName}"]`).value = document.querySelector(`[data-name="${targetName}"] .static-wrap`).getAttribute("data-original-value");
                    document.querySelector(`[data-property="${targetName}"]`).focus();
                    editSaveState();
                });
            });

            document.querySelectorAll(".survey-settings .close-edit").forEach(icon => {
                icon.addEventListener("click", () => {
                    let targetName = icon.getAttribute("data-name");

                    document.querySelector(`[data-name="${targetName}"] .static-wrap`).classList.remove("hide");
                    document.querySelector(`[data-name="${targetName}"] .input-wrap`).classList.add("hide");
                    
                    let input = document.querySelector(`[data-property="${targetName}"]`);
                    input.value = document.querySelector(`[data-name="${targetName}"] .static-wrap`).getAttribute("data-original-value");
                })
            })

            nodes.surveySettings.notificationToggle.addEventListener("change", ()=> {
                editSaveState(); 
            })

            nodes.surveySettings.commentsToggle.addEventListener("change", (event)=> {
                editSaveState(); 
                if(event.target.checked) {
                    nodes.surveySettings.marketingPermissionsWrap.classList.remove("disabled");
                } else {
                    nodes.surveySettings.marketingPermissionsWrap.classList.add("disabled");
                    nodes.surveySettings.marketingPermissionsToggle.checked = false;
                    nodes.surveySettings.googleReviewsToggle.checked = false;
                }
            })

            nodes.surveySettings.marketingPermissionsToggle.addEventListener("change", ()=> {
                editSaveState(); 
            })

            nodes.surveySettings.googleReviewsToggle.addEventListener("change", (event)=> {
                if(event.target.checked) {
                    nodes.surveySettings.googleUrlWrap.classList.remove("disabled");
                    nodes.surveySettings.googleReviewsInput.disabled = false;
                } else {
                    nodes.surveySettings.googleUrlWrap.classList.add("disabled");
                    nodes.surveySettings.googleReviewsInput.disabled = true;
                }
                editSaveState();
            })

            nodes.surveySettings.surveyStatus.addEventListener("change", event => {
                if (event.target.checked) {
                    nodes.surveySettings.surveyStatusLabel.innerText = "Active";
                    nodes.surveySettings.surveyStatusLabel.classList.remove("paused");
                } else {
                    nodes.surveySettings.surveyStatusLabel.innerText = "Paused";
                    nodes.surveySettings.surveyStatusLabel.classList.add("paused");
                }

                editSaveState();
            })

            nodes.surveySettings.projectStatusToggle.addEventListener("change", event => {
                if(event.target.checked) {
                    nodes.surveySettings.projectStatusWrap.classList.remove("disabled");
                } else {
                    nodes.surveySettings.projectStatusWrap.classList.add("disabled");
                }

                editSaveState();
            })

            nodes.surveySettings.phaseAndStatusToggle.addEventListener("change", event => {
                if(event.target.checked) {
                    nodes.surveySettings.phaseStatusDescription.classList.remove("disabled");
                } else {
                    nodes.surveySettings.phaseStatusDescription.classList.add("disabled");
                }

                editSaveState();
            })

            nodes.surveySettings.saveButton.addEventListener("click", () => {
                updateSurveySettings();
            });

            nodes.deleteButtons.forEach(button => {
                button.addEventListener("click", () => {
                    deleteSurvey();
                });
            })

            nodes.contacts.editContactsButton.addEventListener("click", () => {
                toggleContactsEditing(true)

                let checkedBoxes = 0;
                let contactsCheckboxes = document.querySelectorAll(".contacts-table tbody input[type=checkbox]");

                nodes.contacts.checkAllContacts.addEventListener("change", (e) => {
                    contactsCheckboxes.forEach(box => {
                        box.checked = e.target.checked;
                    })

                    if (e.target.checked) {
                        checkedBoxes = contactsCheckboxes.length;
                    } else {
                        checkedBoxes = 0;
                    }
                })
            
                contactsCheckboxes.forEach(checkbox => {
                    if(checkbox.checked) checkedBoxes ++;

                    checkbox.addEventListener("change", (e) => {
                        if(checkbox.checked) {
                            checkedBoxes ++;
                        } else {
                            checkedBoxes --;
                        }

                        if (checkedBoxes === contactsCheckboxes.length) {
                            nodes.contacts.checkAllContacts.checked = true;
                        } else {
                            nodes.contacts.checkAllContacts.checked = false;
                        }
                    })
                })
            })

            nodes.contacts.editContactsCancel.addEventListener("click", () => {
                toggleContactsEditing(false)
            })

            nodes.contacts.editContactsSave.addEventListener("click", () => {
                saveContacts();
            })

            nodes.manualContacts.addContactButton.addEventListener("click", (e) => {
                let contactRow = `
                    <div class="contact">
                        <div class="field-wrap">
                            <input class="first-name" value="" placeholder="First Name" name="">
                            <div class="error input-error error-first-name hide">Invalid characters</div>
                        </div>
                        <div class="field-wrap">
                            <input class="last-name" value="" placeholder="Last Name" name="">
                            <div class="error input-error error-last-name hide">Please enter a value</div>
                        </div>
                        <div class="field-wrap">
                            <input class="email" value="" placeholder="Email" name="">
                            <div class="error input-error error-email hide">Invalid email</div>
                        </div>
                        <div class="remove glyphicons glyphicons-remove-sign"></div>
                    </div>    
                `;

                e.preventDefault();
                buildValidationConfigs();

                let formIsValid = utilities.validateForm(contactValidationConfigs, nodes.manualContacts.manualContactsWrap);

                if(formIsValid) {            
                    nodes.manualContacts.manualContactsWrap.insertAdjacentHTML("beforeend", contactRow);
                    let hiddenRemoveIcons = document.querySelectorAll(".glyphicons-remove-sign.hide");
                    hiddenRemoveIcons.forEach(icon => {
                        icon.classList.remove("hide");
                    })
                }
            })

            // using event delegation for remove buttons as they are generated dynamically
            nodes.manualContacts.manualContactsWrap.addEventListener("click", event => {
                // only target remove buttons
                if(!event.target.classList.contains("remove")) return;
                // remove question element
                event.target.parentElement.remove();
                
                let manualContacts = nodes.manualContacts.manualContactsWrap.querySelectorAll(".contact");
                if(manualContacts.length === 1) {
                    // hide remove contact button if only one input is present
                    document.querySelector(".glyphicons-remove-sign").classList.add("hide");
                }
            })

            nodes.surveySettings.viewEmailButton.addEventListener("click", () => {
                showPreview("email");
            })

            nodes.surveySettings.viewSurveyButton.addEventListener("click", () => {
                showPreview("survey");
            })     

            selectizePhase.on("change", () => {
                editSaveState();
                utilities.setSettingsHeight(nodes.surveySettings);
            })

            window.addEventListener("resize", () => {
                utilities.setSettingsHeight(nodes.surveySettings);
            });
        }

        return {
            init: function () {

                if(browser_storage.getItem("survey-global-stats-collapse") === "false") {
                    nodes.globalMetrics.classList.add("no-transition");
                    nodes.globalMetrics.classList.remove("collapse");
                    nodes.globalMetrics.classList.remove("no-transition");
                }

                // check for active surveys
                if(nodes.surveySelectorOptions.length) {
                    DDSurveySelector = DD(nodes.surveySelectorWrap, (value) => {
                        getSurvey(value, null, true);
                    });

                    // get last visited survey or first survey in list
                    let lastSurvey =  browser_storage.getItem("last-visited-survey");
                    let surveyExists = false;
                    // check if saved survey still exists
                    nodes.surveySelectorOptions.forEach(option => {
                        if(option.value === lastSurvey) {
                            surveyExists = true;
                        }
                    })
                    if(lastSurvey && lastSurvey.length && surveyExists) {
                        getSurvey(lastSurvey, null, true);
                        DDSurveySelector.chooseOption(lastSurvey);
                    } else {
                        getSurvey(nodes.surveySelectorOptions[0].value, null, true);
                    }
                    
                } else {
                    nodes.noSurveysWrap.classList.remove("hide");

                    let supressDialog = browser_storage.getItem("supress-projects-dialog")
                    
                    if(!supressDialog || supressDialog === 'false') {
                        createdModal.open({
                            class: "welcome-modal",
                            content: nodes.welcomeModal.innerHTML,
                            title: "Welcome to Project Surveys!"
                        }, function (el) {
    
                            let supressDialogInput = el.querySelector(".supress-dialog input");
    
                            supressDialogInput.addEventListener("change", (event) => {
                                if(event.target.checked) {
                                    browser_storage.setItem("supress-projects-dialog", true);
                                } else {
                                    browser_storage.setItem("supress-projects-dialog", false);
                                }
                            })
                        });
                    }
                }                

                createEventListeners();
            }
        }
    }
);
